import type { PDFFont, PDFPage, RGB } from 'pdf-lib'

export const MAX_FILE_MB = 100
const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export const POSITIONS = ['bottom-center', 'bottom-right', 'top-right'] as const
export type PageNumberPosition = (typeof POSITIONS)[number]

export function positionLabel(pos: PageNumberPosition): string {
  switch (pos) {
    case 'bottom-center':
      return 'Снизу по центру'
    case 'bottom-right':
      return 'Снизу справа'
    case 'top-right':
      return 'Сверху справа'
  }
}

export function positionLabelEn(pos: PageNumberPosition): string {
  switch (pos) {
    case 'bottom-center':
      return 'Bottom center'
    case 'bottom-right':
      return 'Bottom right'
    case 'top-right':
      return 'Top right'
  }
}

export function numberedFilename(originalName: string): string {
  const dotIndex = originalName.lastIndexOf('.')
  const base = dotIndex !== -1 ? originalName.slice(0, dotIndex) : originalName
  return `${base}-numbered.pdf`
}

export function validateFileSize(file: File): boolean {
  return file.size <= MAX_FILE_BYTES
}

/**
 * Draw a page number on a PDF page at the given position.
 * Uses a small, semi-transparent number so it doesn't distract.
 */
export function drawPageNumber(
  page: PDFPage,
  pageNumber: number,
  position: PageNumberPosition,
  font: PDFFont,
  color: RGB,
): void {
  const { width, height } = page.getSize()
  const fontSize = 10
  const text = String(pageNumber)

  let x: number
  let y: number

  const padding = 30

  switch (position) {
    case 'bottom-center':
      x = width / 2 - font.widthOfTextAtSize(text, fontSize) / 2
      y = padding
      break
    case 'bottom-right':
      x = width - padding - font.widthOfTextAtSize(text, fontSize)
      y = padding
      break
    case 'top-right':
      x = width - padding - font.widthOfTextAtSize(text, fontSize)
      y = height - padding - fontSize
      break
  }

  page.drawText(text, {
    x,
    y,
    size: fontSize,
    font,
    color,
  })
}
